/* eslint-disable react/no-unused-class-component-methods */
import React from 'react'
import { IOrder, IOrderProductItem, ISelectedStoreMap, IXShipping } from 'x/index'
// import { NavigationScreenProp, NavigationState } from 'react-navigation'
import * as util from 'x/utils/util'
import _ from 'lodash'
import api from 'x/utils/api'
import p from 'x/config/platform-specific'

interface IIMultiParcel {
  order_id: number
  parcels: IParcel[]
}

export interface IParcel {
  items: {
    pp_id: number
    qty: number
    product_bundle_id?: number
  }[]
  x?: IXShipping
  // isHaveDeleteBtn => เอาไว้บอกว่า Parcel อันไหนเป็นอันเก่า  เพราะถ้าเป็นอันเก่าจะไม่สามารถลบออกได้
  isHaveDeleteBtn?: boolean
}

interface BaseMultiParcelViewProps {
  navigation: any
  selectedStore: ISelectedStoreMap
}

interface BaseMultiParcelViewState {
  order: IOrder
  multiParcel: IParcel[]
  amountQty: number
  products: IOrderProductItem[]

  isHaveChange: boolean
  isShowBtnDeleteParcels: boolean
  // isHaveXShipping: boolean
  isSubmitting: boolean

  inputDivideParcels: string
  isVisibleOverlayDivideParcels: boolean
}

export default class BaseMultiParcelView extends React.Component<BaseMultiParcelViewProps, BaseMultiParcelViewState> {
  inProcess: boolean

  constructor(props) {
    super(props)
    this.state = {
      order: null,
      multiParcel: null,
      products: null,
      isHaveChange: false,
      amountQty: 0,
      isShowBtnDeleteParcels: false,
      // isHaveXShipping: false,
      isSubmitting: false,

      inputDivideParcels: '',
      isVisibleOverlayDivideParcels: false,
    }
    this.inProcess = false
  }

  async componentDidMount() {
    // await this._setConfig()
    // const { navigation } = this.props
    // console.log('navigation => ', navigation)
    // console.log('navigation // => ', navigation.state)
    // @ts-ignore
    const params = util.getNavParams(this.props)
    // console.log('params => ', params)
    const { order } = params
    // console.log('order => ', order)
    let amountQty = 0
    const products = _.isNil(order) ? null : order.products
    if (!_.isNil(order)) {
      products.forEach((product) => {
        if (_.has(product, 'bundle_product_mappings')) {
          const { bundle_product_mappings } = product
          bundle_product_mappings.forEach((mapping) => {
            amountQty += mapping.qty
            amountQty -= mapping.shipped_qty
          })
        } else {
          // @ts-ignore
          amountQty += product.qty
          // @ts-ignore
          amountQty -= product.shipped_qty
        }
      })
    }
    // console.log('order => ', order)
    // console.log('order => ', order.products)
    this.setState({
      order,
      multiParcel: [],
      amountQty,
      products,
    })

    await this._fetchMultiParcel(order)
  }

  _showOverlayDivideParcels = () => {
    this.setState({
      isVisibleOverlayDivideParcels: true,
    })
  }

  _closeOverlayDivideParcels = () => {
    this.setState({
      isVisibleOverlayDivideParcels: false,
    })
  }

  _submitDivideParcels = () => {
    // const { multiParcel, inputDivideParcels, order } = this.state
    // const newMultiParcel = _.isNil(multiParcel) ? [] : multiParcel
    // const { products } = order
    // console.log('products => ', products)
    // // const doneParcel = false
    // // // @ts-ignore
    // // const newProducts: IOrderProductItem[] = []
    // let useCount = 0
    // const items = []
    // products.forEach((product) => {
    //   console.log('product => ', product)
    //   const productQty = product.qty - product.shipped_qty
    //   console.log('productQty => ', productQty)
    //   // if (productQty < +inputDivideParcels) {
    //   for (let i = 0; i <= productQty; i++) {
    //     console.log('useCount => ', useCount)
    //     if (useCount < +inputDivideParcels) {
    //       useCount += 1
    //       newMultiParcel.push({
    //         items: [
    //           {
    //             pp_id: product.pp_id,
    //             qty: 1,
    //           },
    //         ],
    //       })
    //     } else {
    //       const item = {
    //         pp_id: product.pp_id,
    //         qty: product.qty,
    //       }
    //       items.push(item)
    //     }
    //   }
    //   // }
    //   // @ts-ignore
    //   newMultiParcel.push(items)
    // })
    // this.setState({
    //   multiParcel: newMultiParcel,
    // })
    // this._closeOverlayDivideParcels()
  }

  _goBack = () => {
    // @ts-ignore
    const params = util.getNavParams(this.props)
    const { callBackRerender } = params
    if (_.isFunction(callBackRerender)) {
      callBackRerender(true)
    }
    // @ts-ignore
    util.navGoBack(this.props)
  }

  _startSubmitting = async () => {
    this.inProcess = true
    await util.setStatePromise(this, {
      isSubmitting: true,
    })
  }

  _stopSubmitting = async () => {
    this.inProcess = false
    await util.setStatePromise(this, {
      isSubmitting: false,
    })
  }

  _setIsHaveDeleteBtn = (parcels: IParcel[]) =>
    parcels.map((parcel) => ({
      ...parcel,
      isHaveDeleteBtn: false,
    }))

  _fetchMultiParcel = async (order: IOrder) => {
    const { selectedStore } = this.props
    const apiOptions = {
      showSpinner: true,
    }
    const body: { [key: string]: any } = {
      store_id: selectedStore.get(`id`),
      order_id: order.id,
    }
    if (this.inProcess) {
      return
    }
    await this._startSubmitting()
    const res = await api.postV2(api.POST_MULTIPARCEL_LIST, body, apiOptions)
    // console.log('res => ', res)
    const newParcels = this._setIsHaveDeleteBtn(res.parcels)
    // console.log('newParcels => ', newParcels)
    if (res.order_id) {
      await util.setStatePromise(this, {
        multiParcel: newParcels,
        isShowBtnDeleteParcels: newParcels.length > 0,
        isHaveChange: false,
      })
    }
    await this._stopSubmitting()
  }

  _submitMultiParcel = async () => {
    const { selectedStore } = this.props
    const { order, multiParcel } = this.state
    if (_.isNil(order)) {
      return
    }
    const apiOptions = {
      showSpinner: true,
    }
    const parcels = []
    multiParcel.forEach((parcel) => {
      if (_.isNil(parcel.isHaveDeleteBtn)) {
        parcels.push(parcel)
      }
    })
    const body: { [key: string]: any } = {
      store_id: selectedStore.get('id'),
      order_id: order.id,
      parcels,
    }
    if (this.inProcess) {
      return
    }
    await this._startSubmitting()
    // console.log('body => ', body)
    const res: {
      order_id: number
      parcels: IParcel[]
    } = await api.postV2(api.POST_MULTIPARCEL_CREATE, body, apiOptions)
    // console.log('res => ', res)
    if (res.order_id) {
      const newParcels = this._setIsHaveDeleteBtn(res.parcels)
      p.op.showToast('สร้างหลายพัสดุเรียบร้อยแล้ว', 'success')
      await util.setStatePromise(this, {
        multiParcel: newParcels,
        isShowBtnDeleteParcels: newParcels.length > 0,
        isHaveChange: false,
      })
    }
    await this._stopSubmitting()
  }

  _deleteParcel = (index: number) => {
    const { multiParcel } = this.state
    if (_.isNil(multiParcel)) {
      return
    }
    const newParcels = []
    multiParcel.forEach((parcel, idx) => {
      if (idx !== index) {
        newParcels.push(parcel)
      }
    })
    this.setState({ multiParcel: newParcels })
  }

  _deleteAllParcel = async () => {
    const { selectedStore } = this.props
    const { order } = this.state

    const confirm = await new Promise<boolean>((passConfirm) => {
      p.op.showConfirmation(
        'ลบพัสดุทั้งหมด',
        'กดปุ่ม "ยืนยัน" หากต้องการลบพัสดุทั้งหมด\nหากพัสดุมีเลขพัสดุจากขนส่งแล้ว จะใช้เวลาในการลบพัสดุนานกว่าปกติ',
        () => passConfirm(true),
        () => passConfirm(false),
        'ยืนยัน',
        'ยกเลิก'
      )
    })
    if (!confirm) {
      return
    }

    if (_.isNil(order)) {
      return
    }
    if (this.inProcess) {
      return
    }
    await this._startSubmitting()
    const apiOptions = {
      showSpinner: true,
      axiosOptions: {
        retry: 0,
        timeout: 15000, // long fetch 15 วินาที
      },
    }
    const body = {
      store_id: selectedStore.get('id'),
      order_id: order.id,
    }

    try {
      const res: {
        order_id: number
        parcels: IParcel[]
      } = await api.postV2(api.POST_MULTIPARCEL_DELETE, body, apiOptions)
      // console.log('res => ', res)
      if (res.order_id) {
        p.op.showToast('ลบรายการพัสดุทั้งหมดเรียบร้อยแล้ว', 'success')
        const newParcels = this._setIsHaveDeleteBtn(res.parcels)
        await util.setStatePromise(this, {
          multiParcel: newParcels,
          isShowBtnDeleteParcels: newParcels.length > 0,
          isHaveChange: false,
        })
      }
    } catch (error) {
      // console.log('ERR => ', error)
      p.op.showConfirmationOkOnly('ระบบกำลังยกเลิกการแบ่งพัสดุ', 'อาจจะใช้เวลาหลายนาที  กรุณาตรวจสอบอีกครั้งภายหลัง', () => this._goBack())
    }
    await this._stopSubmitting()
  }

  _createTackingCode = async () => {
    const { selectedStore } = this.props
    const { order } = this.state
    const apiOptions = {
      showSpinner: true,
    }
    const body: { [key: string]: any } = {
      store_id: selectedStore.get('id'),
      order_id: order.id,
    }
    const res = await api.post(api.POST_CREATE_TACKING_CODE, body, apiOptions)
    if (res && res.x) {
      this._fetchMultiParcel(order)
    } else {
      p.op.showToast('ไม่สามารถสร้างเลขติดตามพัสดุได้ในขณะนี้', 'warning')
    }
  }

  _callBackFormSelectedProduct = (newParcel: IParcel[]) => {
    // console.log('callBackFormSelectedProduct newParcel => ', newParcel)
    this.setState({
      multiParcel: newParcel,
      isHaveChange: true,
    })
  }

  _checkMultiParcelCount = () => {
    const { multiParcel, products } = this.state
    let qtyShipped = 0
    let countTotal = 0
    if (!_.isNil(multiParcel)) {
      multiParcel.forEach((parcel) => {
        parcel.items.forEach((itam) => {
          countTotal += itam.qty
        })
      })
    }
    if (!_.isNil(products)) {
      products.forEach((product) => {
        if (_.has(product, 'bundle_product_mappings')) {
          const { bundle_product_mappings } = product
          bundle_product_mappings.forEach((mapping) => {
            // countTotal += mapping.qty
            qtyShipped += mapping.shipped_qty
          })
        } else {
          qtyShipped += product.shipped_qty
        }
      })
    }
    // console.log('countTotal => ', countTotal)
    // console.log('qtyShipped => ', qtyShipped)
    return countTotal - qtyShipped
  }

  _confirmAutoSetParcels = async () => {
    const { amountQty } = this.state
    const countTotal = this._checkMultiParcelCount()
    const finnalCount = amountQty - countTotal
    const confirm = await new Promise<boolean>((passConfirm) => {
      p.op.showConfirmation(
        'ระบุ "พัสดุละชิ้น" โดยอัตโนมัติ',
        `เมื่อกดปุ่มยืนยัน "แบ่งพัสดุอัตโนมัติ" ระบบจะทำการแบ่งพัสดุสำหรับสินค้า ${finnalCount} ชิ้นที่ยังไม่ได้ระบุพัสดุให้โดยอัตโนมัติ โดยจะแบ่งเป็น ${finnalCount} พัสดุๆละ 1 ชิ้น`,
        () => passConfirm(true),
        () => passConfirm(false),
        'ยืนยัน',
        'ยกเลิก'
      )
    })
    return confirm
  }

  _autoSetParcels = async () => {
    // เรียกใช้ฟังก์ชันเพื่อยืนยันการตั้งค่าพัสดุอัตโนมัติ
    const confirm = await this._confirmAutoSetParcels()
    // ถ้าไม่ได้รับการยืนยัน ให้หยุดการทำงานของฟังก์ชัน
    if (!confirm) {
      return
    }
    // ดึงข้อมูล multiParcel และ products จาก state
    const { multiParcel, products } = this.state
    // console.log('products => ', products)
    // console.log('multiParcel => ', multiParcel)
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const result = [...multiParcel.map((p) => ({ items: [...p.items] }))]

    // นับจำนวนที่มีอยู่แล้ว
    const countExisting = {}
    result.forEach((parcel) => {
      parcel.items.forEach((item) => {
        const key = item.pp_id + '_' + (item.product_bundle_id ?? '')
        countExisting[key] = (countExisting[key] || 0) + item.qty
      })
    })

    // helper สำหรับเพิ่ม parcel
    const addParcel = (pp_id, product_bundle_id = undefined) => {
      const parcelItem = { pp_id, qty: 1 }
      if (product_bundle_id) parcelItem.product_bundle_id = product_bundle_id
      result.push({ items: [parcelItem] })
    }

    // loop products
    products.forEach((prod) => {
      if (prod.bundle_product_mappings) {
        // ใช้ qty ของ bundle โดยตรง ไม่คูณ product.qty
        prod.bundle_product_mappings.forEach((bundle) => {
          const key = bundle.pp_id + '_' + (bundle.product_bundle_id ?? '')
          const required = bundle.qty // ใช้ตรง ๆ
          const existing = countExisting[key] || 0
          const needAdd = required - existing

          for (let i = 0; i < needAdd; i++) {
            addParcel(bundle.pp_id, bundle.product_bundle_id)
          }

          countExisting[key] = existing + needAdd
        })
      } else {
        // สินค้าธรรมดา
        const key = prod.pp_id + '_' + (prod.product_bundle_id ?? '')
        const required = prod.qty
        const existing = countExisting[key] || 0
        const needAdd = required - existing

        for (let i = 0; i < needAdd; i++) {
          addParcel(prod.pp_id, prod.product_bundle_id)
        }

        countExisting[key] = existing + needAdd
      }
    })
    // eslint-disable-next-line react/no-unused-state
    this.setState({ multiParcel: result, isHaveChange: true })
  }
}
